import { useEffect, useState } from 'react';
import { Button, Dimmer, Form, FormField, FormGroup, Header, Icon, Input, Loader, Message, Radio, Select } from "semantic-ui-react";
import SimpleReactValidator from 'simple-react-validator';
import countryOptions from './countries';

const ReviewNameCustomization = (props) => {
    const getTerm = props.getTerm;

    const [errorString, setError] = useState();

    const [country, setCountry] = useState("US");
    const [altNameToggle, setAltNameToggle] = useState(false);
    const [altName, setAltName] = useState("");
    const [altNameError, setAltNameError] = useState();
    const [nonLatinNameToggle, setNonLatinNameToggle] = useState(false);
    const [nonLatinSurname, setNonLatinSurname] = useState("");
    const [nonLatinGivenNames, setNonLatinGivenNames] = useState("");
    const [preferredToggle, setPreferredToggle] = useState('false');
    const [preferredName, setPreferredName] = useState("");

    const [loading, setLoading] = useState(false);

    const validator = new SimpleReactValidator();

    const [firstName, setFirstName] = useState("");

    useEffect(() => {
        let details = props.participantDetails;
        setCountry(details.HomeCountry);
        setFirstName(details.FirstName);

        if (details.PersonAliases && details.PersonAliases.length > 0) {
            // Find nickname
            const foundNickname = details.PersonAliases.find((element) => element.AliasType === "nickname");
            if (foundNickname) {
                setAltNameToggle(true);
                setAltName(foundNickname.GivenNames);
            }

            // Find non-latin
            const foundNonLatin = details.PersonAliases.find((element) => element.AliasType === "non-latin");
            if (foundNonLatin) {
                setNonLatinNameToggle(true);
                setNonLatinSurname(foundNonLatin.Surname);
                setNonLatinGivenNames(foundNonLatin.GivenNames);
            }

            // Find preferred
            const foundPreferred = details.PersonAliases.find((element) => element.AliasType === "preferred");
            if (foundPreferred) {
                setPreferredToggle('true');
                setPreferredName(foundPreferred.GivenNames);
            }
        }
    }, []);

    const submitForm = (e) =>
    {
        setError();
        setAltNameError();
        // setGivenNamesError();
        // setCountryError();

        let hasErrors = false;

        if (altNameToggle)
        {
            if (!validator.check(altName, 'alpha_space'))
            {
                setAltNameError({ content: getTerm("6d8ca1c8-d515-11f0-9cd9-0ac9221eb135", "Please use only Latin characters in this field. Your name includes invalid characters."), pointing: 'left' });
                hasErrors = true;
            }
        }

        if (!hasErrors) {
            setLoading(true);

            const aliases = [];

            if (altNameToggle && altName.trim().length > 0) {
                aliases.push({
                    "AliasType": "nickname",
                    "GivenNames": altName.trim(),
                    "IsPreferred": false
                });
            }

            if (nonLatinNameToggle && (nonLatinSurname.trim().length > 0 || nonLatinGivenNames.trim().length > 0)) {
                aliases.push({
                    "AliasType": "non-latin",
                    "Surname": nonLatinSurname.trim(),
                    "GivenNames": nonLatinGivenNames.trim(),
                    "Fullname": nonLatinGivenNames.trim() + " " + nonLatinSurname.trim(),
                    // "AliasLanguageTag": "ja",
                    "IsPreferred": false
                });
            }

            // if (preferredToggle == 'false') {
            //     aliases.push({
            //         "AliasType": "preferred",
            //         "GivenNames": data.FirstName,
            //         "IsPreferred": true
            //     });
            // }
            if (preferredToggle == 'true' && preferredName.trim().length > 0) {
                aliases.push({
                    "AliasType": "preferred",
                    "GivenNames": preferredName.trim(),
                    "IsPreferred": true
                });
            }

            props.dataManager.updateAliases(props.jwt, aliases, country)
                .then(response => {
                    setLoading(false);
                    if (typeof response.data.success !== "undefined") {
                        if (response.data.success == 0) {
                            setError(response.data.errorMessage);
                        } else {
                            // Update participantDetails with new aliases
                            props.participantDetails.PersonAliases = aliases;
                            props.setParticipantDetails(props.setParticipantDetails);

                            if (props.requirePhotoUpdate) {
                                props.setStep("photo");
                            } else {
                                props.setStep("updateComplete");
                            }
                            // setLoading(false);
                        }
                    }
                    else
                    {
                        setError(response.data);
                        setLoading(false);
                    }
                });
        }
        else
        {
            setError(getTerm("c893573c-d13d-11f0-8346-0ac9221eb135", "Please review the fields marked below."));
        }
    }

    const options = countryOptions;

    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>{getTerm("bda913ca-d13d-11f0-8346-0ac9221eb135", "Loading")}</Loader>
            </Dimmer>

            <Header as='h2' style={{marginTop: 0}}>{getTerm("0bab7558-d47d-11f0-9cd9-0ac9221eb135", "Personal Information Review: Name Customization")}</Header>
            <div>
                <p>{getTerm("6c01ec34-d47d-11f0-9cd9-0ac9221eb135", "The IATF will use your passport-aligned name to recognize you officially, but recognizes that some people prefer or typically use different forms of address.  Please answer the questions below to help us more easily identify you and customize how the ADP will address you.")}</p>
            </div>

            { (typeof errorString !== "undefined") &&
            <Message error icon>
                <Icon name='exclamation' />
                <Message.Content>
                <Message.Header>{getTerm("c2d4a314-d13d-11f0-8346-0ac9221eb135", "An error occurred")}</Message.Header>
                {errorString}
                </Message.Content>
            </Message>
            }

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>

                <div style={{marginLeft: '3em'}}>
                    <div>
                        <p dangerouslySetInnerHTML={{__html: getTerm("f68bb6e6-d47d-11f0-9cd9-0ac9221eb135", "<strong>In what country do you currently <u><em>live</em></u>?</strong> (Your own personal home country, NOT your CB office.)")}}></p>
                        <FormField
                            // required
                            control={Select}
                            options={options}
                            onChange={(e, { value }) => setCountry(value)} value={country}
                            style={{marginLeft: '4em', width: '30em'}}
                            search
                        />
                    </div>

                    <div style={{marginTop: '2em'}}>
                        <div className='center'>
                            <Radio toggle style={{marginRight: '1em'}} checked={altNameToggle} onChange={() => setAltNameToggle(!altNameToggle)} />
                            <span>{getTerm("29f46c2e-d480-11f0-9cd9-0ac9221eb135", 'Do you use an alternative given name in business? (e.g., Nickname/"Western Name")')}</span>
                        </div>
                        <FormGroup>
                            <div style={{ display: !altNameToggle ? 'none' : 'block'}}>
                                <FormField
                                    // required
                                    control={Input}
                                    onChange={(e) => setAltName(e.target.value)} value={altName}
                                    disabled={!altNameToggle}
                                    // error={{
                                    //     content: 'Please enter a valid email address'
                                    // }}
                                    error={altNameError}
                                    style={{marginTop: '1em', marginLeft: '4.5em', width: '30em'}}
                                />
                                <span style={{marginLeft: '4.5em'}}>{getTerm("2e8685be-d481-11f0-9cd9-0ac9221eb135", 'Alternative given name (in Latin characters)')}</span>
                            </div>
                        </FormGroup>
                    </div>

                    <div style={{marginTop: '2em'}}>
                        <div className='center'>
                            <Radio toggle style={{marginRight: '1em'}} checked={nonLatinNameToggle} onChange={() => setNonLatinNameToggle(!nonLatinNameToggle)}/>
                            <span>{getTerm("5e8dd858-d480-11f0-9cd9-0ac9221eb135", 'Do you typically write your name in a non-Latin characters? (e.g., Chinese, Japanese, Korean, etc.)')}</span>
                        </div>
                        <FormGroup className="non-latin-form-group">
                            <div style={{ display: !nonLatinNameToggle ? 'none' : 'block'}}>
                                <FormField
                                    // required
                                    control={Input}
                                    onChange={(e) => setNonLatinSurname(e.target.value)} value={nonLatinSurname}
                                    disabled={!nonLatinNameToggle}
                                    // error={{
                                    //     content: 'Please enter a valid email address'
                                    // }}
                                    // error={givenNamesError}
                                    style={{marginTop: '1em', marginLeft: '4em', width: '30em'}}
                                />
                                <span style={{marginLeft: '4em'}}>{getTerm("59a05dba-d481-11f0-9cd9-0ac9221eb135", 'Surname (in your alphabet)')}</span>
                            </div>

                            <div style={{ display: !nonLatinNameToggle ? 'none' : 'block'}}>
                                <FormField
                                    // required
                                    control={Input}
                                    onChange={(e) => setNonLatinGivenNames(e.target.value)} value={nonLatinGivenNames}
                                    disabled={!nonLatinNameToggle}
                                    // error={{
                                    //     content: 'Please enter a valid email address'
                                    // }}
                                    // error={givenNamesError}
                                    style={{marginTop: '1em', marginLeft: '4em', width: '30em'}}
                                />
                                <span style={{marginLeft: '4em'}}>{getTerm("72556cc4-d481-11f0-9cd9-0ac9221eb135", 'Given names (in your alphabet)')}</span>
                            </div>
                        </FormGroup>
                    </div>

                    <div style={{marginTop: '2em'}}>
                        <p dangerouslySetInnerHTML={{__html: getTerm("ae8c2d18-d481-11f0-9cd9-0ac9221eb135", "<strong>On the IATF ADP website and in official ADP communications, how should we address you?</strong>")}}></p>
                        <FormField>
                            <Radio
                                label={getTerm("23b7bd12-d515-11f0-9cd9-0ac9221eb135", 'As "{name}"').replace('{name}', firstName)}
                                name='radioGroup'
                                value='false'
                                checked={preferredToggle === 'false'}
                                // onChange={this.handleChange}
                                onChange={() => setPreferredToggle('false')}
                                style={{marginLeft: '4em'}}
                            />
                        </FormField>
                        <div className='center'>
                            <FormField style={{margin: 'unset'}}>
                                <Radio
                                    label={getTerm("4d2c4b18-d515-11f0-9cd9-0ac9221eb135", 'As something else:')}
                                    name='radioGroup'
                                    value='true'
                                    checked={preferredToggle === 'true'}
                                    // onChange={this.handleChange}
                                    onChange={() => setPreferredToggle('true')}
                                    style={{marginLeft: '4em'}}
                                />
                            </FormField>
                            <FormField
                                // required
                                control={Input}
                                onChange={(e) => setPreferredName(e.target.value)} value={preferredName}
                                disabled={preferredToggle === 'false'}
                                // error={{
                                //     content: 'Please enter a valid email address'
                                // }}
                                // error={givenNamesError}
                                style={{marginLeft: '4em', width: '30em'}}
                            />
                        </div>
                    </div>
                </div>

                <Message color='blue' icon style={{marginTop: '2.5em', marginBottom: '1em'}}>
                    <Icon name='info circle' style={{fontSize: '1.5em'}}/>
                    <Message.Content style={{color: "black"}} dangerouslySetInnerHTML={{__html: getTerm("464c5b0e-d483-11f0-9cd9-0ac9221eb135", "If you need to make changes to your personal information after this review, please contact the ADP Support Team.")}}>
                    </Message.Content>
                </Message>

                <Button onClick={() => props.setStep("reviewPassport")}>{getTerm("403eb9da-d787-11f0-9cd9-0ac9221eb135", "Previous Step")}</Button>
                {props.requirePhotoUpdate
                    ? <Button type='submit' primary style={{float: 'right'}}>{getTerm("d07f78a4-d13d-11f0-8346-0ac9221eb135", "Next Step")}</Button>
                    : <Button type='submit' primary style={{float: 'right'}}>{getTerm("df2070d8-f231-11f0-9cd9-0ac9221eb135", "Complete Update")}</Button>
                }
            </Form>
        </div>
    )
}

export default ReviewNameCustomization;